import { useEffect, useState } from 'react';
import { Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { SttDialog } from './SttDialog';
import { generateFormField } from '../../lib/utils';

type ActivityForm = {
    id: string | number;
    answer?: {
        value: unknown;
    };
};

type Props = {
    open?: boolean;
    onClose?: () => void;
    onSave: (
        rateId: number | string,
        params: { form: Record<string, unknown> },
    ) => void;
    rateId: number | string;
    activityForms: ActivityForm[];
};

export function SttActivityFillForms({
    open = false,
    onClose,
    onSave,
    rateId,
    activityForms,
}: Props): React.ReactElement {
    const { t } = useTranslation();
    const [forms, setForms] = useState<ActivityForm[]>([]);

    const handleFormFieldChange = ({
        name,
        value,
    }: {
        name: string | undefined;
        value: unknown;
    }) => {
        if (!name) return;
        const formsValues = forms.map((l: any) => ({ ...l }));
        const question = formsValues.find(
            (question: any) => question.id.toString() === name,
        );

        if (question) {
            formsValues.splice(formsValues.indexOf(question), 1, {
                ...question,
                answer: { value },
            });
        }

        setForms(formsValues);
    };

    useEffect(() => {
        setForms(activityForms);
    }, [activityForms]);

    const save = () => {
        const formsParam: Record<string, unknown> = {};

        forms.forEach((form: any) => {
            if (form.answer) {
                formsParam[form.id] = form.answer.value;
            }
        });

        onSave(rateId, { form: formsParam });
    };

    return (
        <SttDialog
            title={t('activity.fillForms')}
            open={open}
            onClose={() => (onClose ? onClose() : null)}
            content={
                <Grid container spacing={3}>
                    {forms &&
                        forms.map((item: any, i: any) => (
                            <Grid key={i} size={{ xs: 12 }}>
                                {generateFormField(item, handleFormFieldChange)}
                            </Grid>
                        ))}
                </Grid>
            }
            buttons={[
                {
                    type: 'save',
                    onClick: () => save(),
                },
                {
                    type: 'close',
                    onClick: onClose,
                },
            ]}
        />
    );
}
